// extracted by mini-css-extract-plugin
export default {"locationFont":"d6gEA5"};